import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { MessageRequest } from '../../requests/srv-message-queue/message.request';

@Injectable({
  providedIn: 'root'
})
export class MessageService extends CommonService {

  constructor(private router: Router,
private httpClient: HttpClient,
configService:AppConfigService,
private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public SendMessage(body: MessageRequest, idHealthUnit: number): Observable<ReturnStruct> {

    return this.httpClient.post<ReturnStruct>(`${this.endpointBuilder.getEndpoint(ApiEnum.urlApiSRVMessageQueue)}Message?idHealthUnit=${idHealthUnit}`, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
